import React from "react";
import { useNavigate } from "react-router-dom";
import css from "../pages/farm/farm-details.module.css";

const Breadcrumb = ({ account }) => {
  const navigate = useNavigate();

    const accountPaths = [
    account?.parent_account?.parent_account?.parent_account?.parent_account,
    account?.parent_account?.parent_account?.parent_account,
    account?.parent_account?.parent_account,
    account?.parent_account,
    account,
  ];
  return (
    <h2>
      {accountPaths
        ?.filter(acct => acct)
        ?.map((acct, index) => (
          <span key={index}>
            <span
              style={
                index < accountPaths.filter(acct => acct).length - 1
                  ? { textDecoration: "underline", cursor: "pointer" }
                  : {}
              }
              onClick={() => {
                navigate(
                  `/${acct?.account_type === "FARM" ? "farm" : acct?.account_type === "SUB_ENTITY" ? "sub-account" : "account"}/${encodeURIComponent(acct?.name)}`
                );
              }}
              className={css.breadcrumb}
            >
              {acct?.name}
            </span>
            {index < accountPaths.filter(acct => acct).length - 1 && " / "}
          </span>
        ))}
    </h2>
  );
};

export default Breadcrumb;